module.exports = __webpack_public_path__ + "img/6.d7724d03.jpg";